module.exports = __webpack_public_path__ + "img/batsman-ready.38ef85a3.png";